// Unpublished Work © 2026 Deere & Company.

export const HEALTH_ALLOWED_USERS = [
    'NSC4QAK', 'S414FES', 'CS16641', 'ZEHBPGR', 'VBWP7GW', 'ZGY5FDV', 'R4V7GFB', 'VD22141', 'AR05520', 'YP85381', 'S4Q3ZXH'
];
